export const MAX_FAVORITE_FUNNELS = 3;

export const FORECAST_COLUMNS_PER_PAGE = 12;
